import { array } from 'fp-ts';
import { BillingSearchForReservationsForLinkingResult, ReservationLinkResult } from '@mews-commander/data-access';
import { EmptyReservationListItem } from './EmptyReservationListItem';
import { DividerReservationListItem } from './DividerReservationListItem';
import { renderReservationItem } from './renderReservationItem';

export enum DividerType {
    OnBill = 'onBill',
    OnProfile = 'onProfile',
    OutsideProfile = 'outsideProfile',
}

export const renderReservationList = (
    rs: BillingSearchForReservationsForLinkingResult,
    ownerId: string,
    scopedReservationIds?: string[]
) => {
    const { left: outsideProfile, right: owned } = array.partition((i: ReservationLinkResult) => i.ownerId === ownerId)(
        rs
    );
    const { left: onProfile, right: onBill } = array.partition(
        (i: ReservationLinkResult) => scopedReservationIds?.includes(i.reservationId) ?? false
    )(owned);

    return [
        <EmptyReservationListItem key="emptyItem" />,
        <DividerReservationListItem key="onBillHeader" resultCount={onBill.length} dividerType={DividerType.OnBill} />,
        ...onBill.map((r: ReservationLinkResult) => renderReservationItem(r)),
        <DividerReservationListItem
            key="onProfileHeader"
            resultCount={onProfile.length}
            dividerType={DividerType.OnProfile}
        />,
        ...onProfile.map((r: ReservationLinkResult) => renderReservationItem(r)),
        <DividerReservationListItem
            key="outsideProfileHeader"
            resultCount={outsideProfile.length}
            dividerType={DividerType.OutsideProfile}
        />,
        ...outsideProfile.map((r: ReservationLinkResult) => renderReservationItem(r)),
    ];
};
